import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormService } from '../form.service';

declare let $:any;

@Component({
  selector: 'hc-screen-intermediate',
  templateUrl: './screen-intermediate.component.html'
})
export class ScreenIntermediateComponent implements OnInit, AfterViewInit {

  hChanged:boolean = false;

  constructor(
    private form : FormService
  ) { }

  /* Is the user (almost) happy? Then we directly submit the form */
  ngOnInit() {
    if (this.form.selectedRange < 3) {
      this.form.submit();
    }
  }

  /* Update wrapper height when expanding the form */
  ngAfterViewInit() {
    $('.support-icons > li').click(() => {
      this.updateHeight();
    }).bind(this);
  }

  updateHeight() {
    if (!this.hChanged) {
      $('.screen').height($(document).height());
      $('.survey-wrapper').height($('.screen').outerHeight());
      this.hChanged = true;
    }
  }

  submitResponse() {
    this.form.submit();
  }

  /* Prevent submit and reload */
  restart() {
    this.form.didSubmit = true;
    window.location.reload();
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/screen-intermediate/screen-intermediate.component.ts